import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  ReqManagerCreateActions,
  UiActions,
  EmailValidateActions,
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestEmailValidate, RequestManagerCreate } from 'src/app/shared/interfaces';
import { RedirectService } from 'src/app/services/redirect.service';
import { ApiResponseStatus, StepsNotClientTypes } from '../../../shared/enums';
import { countries } from '../../bfpe-common/data/countries';
import { civilStatuses } from '../../bfpe-common/data/civilStatuses';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { TagPage } from 'src/app/store/actions/ui.actions';

@Component({
  selector: 'lib-public-landing-foreign-joint',
  templateUrl: './public-landing-foreign-joint.component.html',
  styleUrls: ['../../../global.scss', './public-landing-foreign-joint.component.scss']
})
export class PublicLandingForeignJointComponent implements OnInit, OnDestroy {
  isAdult: boolean;
  dateInvalid: boolean;
  today: string;
  countries: any = countries;
  civilStatuses: any = civilStatuses;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  formData: FormGroup;

  createRequestManager$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.reqManagerCreate)
  );

  emailValidate$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.emailValidateState)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    public loadingService: LoadingService,
    private dataDogService: DatadogService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private redirectService: RedirectService,
    private datePipe: DatePipe
  ) {
    this.formData = this._fb.group({
      fullnameJoint: ['', Validators.required],
      surnameJoint: ['', Validators.required],
      secondSurnameJoint: ['', Validators.required],
      birthdayJoint: ['', Validators.required],
      civilStatusJoint: [null, Validators.required],
      genderJoint: ['', Validators.required]
    });
  }

  emailValidateSuscription = this.emailValidate$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      return this.actionClearnStateAndRedirect(EmailValidateActions);
    }

    if ((response.client && response.client.operationState.code === ApiResponseStatus.OK
      && response.joint && response.joint.operationState.code === ApiResponseStatus.OK) ||
      (response.client && response.client.operationState.code === ApiResponseStatus.DISABLE
        && response.joint && response.joint.operationState.code === ApiResponseStatus.DISABLE)
    ) {
      this.callCreateRequestManager();
    } else {
      this.store.dispatch(EmailValidateActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
    }
  });

  createRequestManagerSubs = this.createRequestManager$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error != null) {
      this.dataDogService.addCustomError(error, 'Landing Error', environment.mode, { channel: 'not client' });
      this.actionClearnStateAndRedirect(ReqManagerCreateActions);
    }
    if (response) {
      if (response.client && response.joint &&
        response.client.operationState.code === ApiResponseStatus.OK && response.joint.operationState.code === ApiResponseStatus.OK) {
        this.callRedirectToOffer();
      } else if (response.client && response.joint
        && (response.client.operationState.code === ApiResponseStatus.FAIL || response.joint.operationState.code === ApiResponseStatus.FAIL)) {
        this.store.dispatch(ReqManagerCreateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      } else {
        this.store.dispatch(ReqManagerCreateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
      }
    }
  });


  ngOnInit() {
    this.store.dispatch(TagPage({text: 'foreign-data-joint'}));
    const fechaActual = new Date();
    const fechaHace18Anios = new Date();
    const maxAge = fechaHace18Anios.setFullYear(fechaActual.getFullYear() - 18);
    this.today = this.datePipe.transform(maxAge, 'yyyy-MM-dd');
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);  }

  ngOnDestroy() {
    this.createRequestManagerSubs.unsubscribe();
  }

  // Metodo para limpiar el estado luego de un error de servicio.
  actionClearnStateAndRedirect(action) {
    this.redirectService.setRedirect(StepsNotClientTypes.STEP_PUBLIC_LANDING);
    this.store.dispatch(action.cleanState());
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
  }

  callRedirectToOffer() {
    this.dataDogService.addCustomEvent('Landing Complete', environment.mode, { channel: 'not client' });
    this.store.dispatch(ReqManagerCreateActions.cleanState());
    this.dataDogService.addCustomEvent('Has offer', environment.mode, { channel: 'not client' });
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_OFFER }));
  }

  continue() {
    if (this.formData.dirty === false || this.formData.invalid) {
      return;
    }

    this.dataNotClientService.setFullnameJoint(this.formData.controls['fullnameJoint'].value);
    this.dataNotClientService.setSurnameJoint(this.formData.controls['surnameJoint'].value);
    this.dataNotClientService.setSecondSurnameJoint(this.formData.controls['secondSurnameJoint'].value);
    this.dataNotClientService.setBirthdayJoint(this.formData.controls['birthdayJoint'].value);
    this.dataNotClientService.setCivilStatusJoint(parseInt(this.formData.controls['civilStatusJoint'].value, 10));
    this.dataNotClientService.setGenderJoint(parseInt(this.formData.controls['genderJoint'].value, 10));
    this.loadingService.loading = true;

    this.callSeon();
  }

  callSeon() {
    const request: RequestEmailValidate = {
      client: {
        cellphone: this.dataNotClientService.getPhoneNumber(),
        email: this.dataNotClientService.getEmail()
      },
      joint: {
        cellphone: this.dataNotClientService.getPhoneNumberJoint(),
        email: this.dataNotClientService.getEmailJoint()
      }
    };

    this.store.dispatch(EmailValidateActions.getEmailValidate({ request }));
  }

  callCreateRequestManager() {
    const request: RequestManagerCreate = this.dataNotClientService.getMainIsClient() ? {
      joint: {
        fullname: this.dataNotClientService.getFullnameJoint(),
        surname: this.dataNotClientService.getSurnameJoint(),
        secondSurname: this.dataNotClientService.getSecondSurnameJoint(),
        birthday: this.dataNotClientService.getBirthdayJoint(),
        civilStatus: this.dataNotClientService.getCivilStatusJoint(),
        gender: this.dataNotClientService.getGenderJoint()
      }
    } : {
      client: {
        fullname: this.dataNotClientService.getFullname(),
        surname: this.dataNotClientService.getSurname(),
        secondSurname: this.dataNotClientService.getSecondSurname(),
        birthday: this.dataNotClientService.getBirthday(),
        civilStatus: this.dataNotClientService.getCivilStatus(),
        gender: this.dataNotClientService.getGender()
      },
      joint: {
        fullname: this.dataNotClientService.getFullnameJoint(),
        surname: this.dataNotClientService.getSurnameJoint(),
        secondSurname: this.dataNotClientService.getSecondSurnameJoint(),
        birthday: this.dataNotClientService.getBirthdayJoint(),
        civilStatus: this.dataNotClientService.getCivilStatusJoint(),
        gender: this.dataNotClientService.getGenderJoint()
      }
    };

    this.store.dispatch(ReqManagerCreateActions.getReqManagerCreate({ request }));
  }
}
